<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from "../../../../../layouts/nav/SNB.vue";
import MyPageCorpInfoView from "@/pages/user/views/mypage/corpJobFair/MyPageCorpInfoView.vue";
import MypageCorpPromotionUserResumeView
  from "@/pages/user/views/mypage/promotion/MypageCorpPromotionUserResumeView.vue";

const route = useRoute();
const router = useRouter();
const tabRef = ref(null);

const snbKey = ref(0);
const corpDetail = ref({}); // 기업정보 관리 상세

const tabOptions = [
  { label: '기업정보 관리', value: 'companyInfo' },
  { label: '입사 지원 현황', value: 'userResume' },
];

const getTabValue = (tab) => {
  return tabOptions.some(option => option.value === tab) ? tab : tabOptions[0].value;
}

const selectedTabValue = ref(getTabValue(route.query.tab));

const onChangeTab = (tab) => {
  selectedTabValue.value = tab.value;

  if (tabRef.value) {
    tabRef.value.init(tab.value);
  }

  if (selectedTabValue.value === tab.value) {
    return;
  }

  router.push({ query: { ...route.query, tab: tab.value } });
};

watch(
  () => route.query.tab,
  (tab) => {
    const nextTabValue = getTabValue(tab);
    selectedTabValue.value = nextTabValue;

    if(tabRef.value) {
      tabRef.value.init(nextTabValue);
    }
  },
  { immediate: true }
);
</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB :key="snbKey" class="snb" />
        <div class="content">
          <div class="sub-title">
            <h3>기업홍보관 현황</h3>
          </div>
          <div class="tab-wrap mb-sm">
            <KSATab
                ref="tabRef"
                :options="tabOptions"
                @change="onChangeTab"
                style="grid-template-columns: repeat(2, 1fr);"
            />
          </div>
          <div v-if="selectedTabValue === 'companyInfo'">
            <MyPageCorpInfoView viewSource="promotion" />
          </div>
          <div v-else-if="selectedTabValue === 'userResume'">
            <MypageCorpPromotionUserResumeView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>
